import React from "react";
import { Confirmation } from "../../../secondary";
import warning from "../../../../static/images/icon-check-danger.png";
import constants from "../../../../constants/constants.json";
import { FormActions } from "../../../secondary/FormActions/FormActions";
import { useLoading } from "../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../constants/loadingKeys";
import { Spinner } from "../../../secondary/Loader/Spinner";

const NotesDeleteConfirmationModal = ({ setDeleteModal, handleDelete }) => {
  const deleteAssessmentNoteLoading = useLoading(LOADING_KEYS.DELETE_ASSESSMENT_NOTE);
  return (
    <Confirmation onClose={() => setDeleteModal(false)} title={" "}>
      <div className="text-center pr-5 pl-5">
        <div>
          {deleteAssessmentNoteLoading ? <Spinner className="p-0" /> : (
            <img src={warning} alt="warnning-icon" />
          )}
        </div>
        <div className="pb-3">{constants.deleteConfirmation}</div>
        <FormActions
          primaryLabel="Yes"
          onPrimaryClick={handleDelete}
          secondaryLabel="No"
          secondaryVariant="outline"
          onSecondaryClick={() => setDeleteModal(false)}
        />
      </div>
    </Confirmation>
  );
};

export default NotesDeleteConfirmationModal;
